export const PERMISSION_NAMES = {
  "TRANSLATIONS": { key: "TRANSLATIONS", label: "Translations" },
  "WEB_SITES": { key: "WEB_SITES", label: "Web sites" },
  "WEBSITES_CONFIGURATION": { key: "WEBSITES_CONFIGURATION", label: "Web sites configuration" },
  "CONFIGURATION": { key: "CONFIGURATION", label: "Configuration" },
  "HELP": { key: "HELP", label: "Help CMS" },
  "TOOLTIPS": { key: "TOOLTIPS", label: "Tooltips" },
  "SEO_RULES": { key: "SEO_RULES", label: "Seo rules" },
  "SEO_RULES_HISTORY": { key: "SEO_RULES_HISTORY", label: "Seo rules history" },
  "BIG_JACKPOT": { key: "BIG_JACKPOT", label: "Big Jackpot" },
  "IMG_ARENA": { key: "IMG_ARENA", label: "Img Arena" },
  "TERMINAL_PAYMENTS": { key: "TERMINAL_PAYMENTS", label: "Terminal Payments" },
  "ICONS": { key: "ICONS", label: "Icons" },
  "GENERAL": { key: "GENERAL", label: "General" },
  "VIP": { key: "VIP", label: "VIP CMS" },
};

export const onlinePermissions = {
  [`${PERMISSION_NAMES.TRANSLATIONS.key}.${PERMISSION_NAMES.TRANSLATIONS.key}`]: '',

  [`${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.TOOLTIPS.key}`]: '',
  [`${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.BIG_JACKPOT.key}`]: '',
  [`${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.IMG_ARENA.key}`]: '',
  [`${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.ICONS.key}`]: '',
  [`${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.GENERAL.key}`]: '',

  [`${PERMISSION_NAMES.HELP.key}.${PERMISSION_NAMES.HELP.key}`]: '',
  [`${PERMISSION_NAMES.VIP.key}.${PERMISSION_NAMES.VIP.key}`]: '',

  [`${PERMISSION_NAMES.WEB_SITES.key}.${PERMISSION_NAMES.WEBSITES_CONFIGURATION.key}`]: '',
  [`${PERMISSION_NAMES.WEB_SITES.key}.${PERMISSION_NAMES.SEO_RULES.key}`]: '',
  [`${PERMISSION_NAMES.WEB_SITES.key}.${PERMISSION_NAMES.SEO_RULES_HISTORY.key}`]: '',
  [`${PERMISSION_NAMES.WEB_SITES.key}.${PERMISSION_NAMES.TOOLTIPS.key}`]: '',

  [`${PERMISSION_NAMES.TERMINAL_PAYMENTS.key}.${PERMISSION_NAMES.TERMINAL_PAYMENTS.key}`]: '',
};
